__turbopack_context__.v({
  "static-tooltip": "StaticTooltip-module-scss-module__T2_0_G__static-tooltip",
  "static-tooltip--right": "StaticTooltip-module-scss-module__T2_0_G__static-tooltip--right",
  "static-tooltip--top": "StaticTooltip-module-scss-module__T2_0_G__static-tooltip--top",
  "static-tooltip__title": "StaticTooltip-module-scss-module__T2_0_G__static-tooltip__title",
  "static-tooltip__tooltip": "StaticTooltip-module-scss-module__T2_0_G__static-tooltip__tooltip",
});
